module.exports = __webpack_public_path__ + "media/src/application/media/help_3-21c94029ba6cabf33be0beb8bc9e3b8c.webp";